module.exports = __webpack_public_path__ + "static/media/psd.be6691be.svg";